import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=4ccfdf00&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QBreadcrumbsEl,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QForm,QField,QInput,QTable,QTr,QTh,QTd,QBtn,QDialog,QCardSection,QSpace,QCardActions,QSelect,QCheckbox,QSpinner,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QBreadcrumbsEl,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QCard,QTabs,QTab,QSeparator,QTabPanels,QTabPanel,QForm,QField,QInput,QTable,QTr,QTh,QTd,QBtn,QDialog,QCardSection,QSpace,QCardActions,QSelect,QCheckbox,QSpinner})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
